import React from 'react';

import UserListComposer from '../../../composers/UserListComposer';

export default function UserListPage(): JSX.Element {
  return <UserListComposer />;
}
